angular.module("componentes").controller("menuRightCtrl", [
	"$scope",
	"$rootScope",
	"clientService",
	"userAccessService",
	"$state",
	"httpService",
	"accountService",
	"translationService",
	"engagementScoreService",
	"permissionService",
	"menuService",
	"featureAccessService",
	function (
		$scope,
		$rootScope,
		clientService,
		userAccessService,
		$state,
		httpService,
		accountService,
		translationService,
		engagementScoreService,
		permissionService,
		menuService,
		featureAccessService
	) {
		var masterViewClientDataPermission;
		var masterEditClientDataPermission;
		var masterViewFeatureToggles;
		var masterMasterPermissionManagement;
		var hasMarketBackOfficePermission;
		var masterExecuteAdminActionsPermission;

		$scope.authentication = $rootScope.authentication;
		var labels = $rootScope.labels;

		$scope.TOSUrl = Vgr.util.getTermsAndConditionsUrl();
		$scope.privacyPolicyUrl = Vgr.util.getPrivacyPolicyUrl();

		$scope.totalItems = 20;
		$scope.clientSearch = "";
		$scope.userSearch = "";
		$scope.canChangeClient = true;
		$scope.canChangeLanguage = false;
		var hasResiduesManagementModule = false;
		var hasSupplierViewModule = false;
		var hasPGRSModule = false;

		var onStateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function (event, state) {
			selectMenuItemFromState(state.name);
		});
		var onChangeLoggedClientInfo = $rootScope.$on(Vgr.constants.evtChangeLoggedClientInfo, function () {
			loadLoginInformation();
		});
		var onChangedLoggedUserInfo = $rootScope.$on(Vgr.constants.evtChangeLoggedUserInfo, function () {
			loadLoginInformation();
		});
		var onChangeLoggedClient = $rootScope.$on(Vgr.constants.evtChangeLoggedClient, function () {
			loadInitialMenuValues();
		});

		this.$onInit = function () {
			$scope.ctrl.activeOption = "allUsers";

			loadInitialMenuValues();
		};

		this.$onDestroy = function () {
			// disable the listener
			onChangeLoggedClient();
			onChangedLoggedUserInfo();
			onChangeLoggedClientInfo();
			onStateChangeSuccess();

			// nullify the DOM-bound model
			$scope.domElement = null;
		};

		function loadInitialMenuValues() {
			loadLoginInformation();
			loadPermissions();
			setUserMenu();
			menuService.applyAccess($scope.userMenu);
			showLanguageChange();

			$scope.isMaster = permissionService.isMaster();
		}

		function loadLoginInformation() {
			$scope.loggedClient = accountService.getCurrentClient();
			$scope.loggedUser = accountService.getLoggedAccount();

			if (!$scope.loggedClient) {
				$scope.nameToDisplay = null;
			} else if (String($scope.loggedClient.code).length > 10) {
				$scope.nameToDisplay = $scope.loggedClient.name;
			} else {
				$scope.nameToDisplay = $scope.loggedClient.code + " - " + $scope.loggedClient.name;
			}
		}

		function loadPermissions() {
			hasResiduesManagementModule = featureAccessService.hasResiduesManagementModule();
			hasSupplierViewModule = featureAccessService.hasSupplierViewModule();
			hasPGRSModule = featureAccessService.hasPGRSModule();
			masterViewClientDataPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterViewClientData);
			masterEditClientDataPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterCreateEditClientData);
			masterViewFeatureToggles = userAccessService.hasAccess(Vgr.systemPermissions.MasterViewFeatureToggles);
			masterMasterPermissionManagement = userAccessService.hasAccess(Vgr.systemPermissions.MasterPermissionManagement);
			hasMarketBackOfficePermission = masterViewClientDataPermission
				? Vgr.enumerations.userAccess.Enabled
				: Vgr.enumerations.userAccess.Hidden;
			masterExecuteAdminActionsPermission = userAccessService.hasAccess(
				Vgr.systemPermissions.MasterExecuteAdminActions
			);
		}

		function showLanguageChange() {
			if (userAccessService.hasAccess(null, null, Vgr.constants.featureToggles.release.changeLanguage)) {
				$scope.canChangeLanguage = true;
			} else {
				$scope.canChangeLanguage = false;
			}
		}

		$scope.toUser = function () {
			$rootScope.$broadcast(Vgr.constants.evtMenuLinkClick);
			$state.go("accountEdit");
		};

		function setUserMenu() {
			var unitMenu = {
				text: function () {
					return labels.UNIT;
				},
				level: 1,
				fixed: true,
				isFree: true,
				children: [
					{
						text: function () {
							return labels.GENERAL_DATA;
						},
						level: 2,
						states: ["unitEdit"],
						stateParams: {
							id: $scope.loggedClient ? $scope.loggedClient.id : null
						},
						isFree: true
					},
					{
						text: function () {
							return labels.AREAS;
						},
						level: 2,
						states: ["unitAreaList", "unitAreaEdit"],
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.RESIDUES;
						},
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						},
						children: [
							{
								text: function () {
									return labels.RECIPIENTS;
								},
								level: 3,
								states: ["recipientList", "recipientEdit"]
							},
							{
								text: function () {
									return labels.RESIDUES;
								},
								level: 3,
								states: ["residueList", "residueEdit"]
							}
						]
					},
					{
						text: function () {
							return labels.PERMISSIONS;
						},
						level: 2,
						states: ["unitPermissionList"],
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.EQUIPMENT;
						},
						level: 2,
						states: ["equipmentList", "equipmentEdit"],
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.DOCUMENTS;
						},
						level: 2,
						states: ["organizationUnitDocumentList", "organizationUnitDocumentEdit"],
						getFeatureAccess: function () {
							return hasPGRSModule ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
						},
						isFree: true
					},
					{
						text: function () {
							return labels.PROCESS_CONTROL;
						},
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						},
						children: [
							{
								text: function () {
									return labels.RAW_MATERIALS;
								},
								level: 3,
								states: ["rawMaterialList", "rawMaterialEdit"]
							},
							{
								text: function () {
									return labels.PRODUCTS;
								},
								level: 3,
								states: ["productList", "productEdit"]
							},
							{
								text: function () {
									return labels.PROCESS_STEPS;
								},
								level: 3,
								states: ["processStepList", "processStepEdit"]
							},
							{
								text: function () {
									return labels.PROCESSES;
								},
								level: 3,
								states: ["processList", "processEdit"]
							}
						]
					}
				]
			};

			var organizationMenu = {
				text: function () {
					return labels.ORGANIZATION;
				},
				level: 1,
				fixed: true,
				isFree: true,
				children: [
					{
						text: function () {
							return labels.GENERAL_DATA;
						},
						states: ["organizationGeneralData"],
						level: 2,
						isFree: true
					},
					{
						text: function () {
							return labels.UNITS;
						},
						states: ["unitList", "unitEdit"],
						level: 2,
						isFree: true
					},
					{
						text: function () {
							return labels.MTR_INTEGRATION;
						},
						states: ["mtrIntegrationList"],
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						},
						isFree: true
					},
					{
						text: function () {
							return labels.USERS;
						},
						states: ["userList"],
						level: 2,
						isFree: true
					},
					{
						text: function () {
							return labels.METADATA;
						},
						states: ["organizationAdditionalPropertiesList"],
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.ORGANIZATION_AREAS_INTERNAL;
						},
						level: 2,
						states: ["areaOrganizationList"],
						getFeatureAccess: function () {
							return hasResiduesManagementModule && (masterViewClientDataPermission || masterEditClientDataPermission)
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.RESIDUES;
						},
						states: ["residueOrganizationList"],
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.COST_CENTERS;
						},
						level: 2,
						states: ["costCenterList", "costCenterEdit"],
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.PERMISSIONS;
						},
						states: ["organizationPermissionList"],
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.SUPPLIER_MANAGEMENT;
						},
						level: 2,
						getFeatureAccess: function () {
							return hasResiduesManagementModule
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						},
						children: [
							{
								text: function () {
									return labels.DOCUMENT_TYPES;
								},
								level: 3,
								states: ["listDocumentType", "editDocumentType"]
							},
							{
								text: function () {
									return labels.ACTING_PROFILE;
								},
								level: 3,
								states: ["listSupplierProfile", "editSupplierProfile"]
							},
							{
								text: function () {
									return labels.AUDIT_MODEL;
								},
								level: 3,
								states: ["listAuditModel"]
							}
						]
					}
				]
			};

			$scope.userMenu = {
				children: [unitMenu, organizationMenu]
			};
			if (masterViewClientDataPermission) {
				$scope.userMenu.children.push(getMasterMenu());
			}
		}

		function getMasterMenu() {
			return {
				text: function () {
					return labels.MASTER;
				},
				level: 1,
				fixed: true,
				isMaster: true,
				children: [
					{
						text: function () {
							return labels.ORGANIZATION_QUERY;
						},
						level: 2,
						isMaster: true,
						states: ["masterOrganizationList", "masterOrganizationEdit"],
						getFeatureAccess: function () {
							return getStandardMasterMenuAccess();
						}
					},
					{
						text: function () {
							return labels.USER_QUERY;
						},
						level: 2,
						isMaster: true,
						states: ["masterUserList"],
						getFeatureAccess: function () {
							return getStandardMasterMenuAccess();
						}
					},
					{
						text: function () {
							return labels.PERMISSIONS;
						},
						level: 2,
						isMaster: true,
						states: ["masterPermissionGroupList", "masterPermissionGroupEdit"],
						getFeatureAccess: function () {
							return masterMasterPermissionManagement
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.FEATURE_TOGGLES;
						},
						level: 2,
						isMaster: true,
						states: ["featureToggleList"],
						getFeatureAccess: function () {
							return masterViewFeatureToggles
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.PLANS;
						},
						level: 2,
						isMaster: true,
						states: ["masterPlanList", "masterPlanEdit"],
						getFeatureAccess: function () {
							return masterExecuteAdminActionsPermission
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.VERTOWN_NOTIFICATIONS;
						},
						level: 2,
						isMaster: true,
						states: ["vertownNotificationList"],
						getFeatureAccess: function () {
							return masterViewClientDataPermission
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					},
					{
						text: function () {
							return labels.DESTINATIONS_IMPORT;
						},
						level: 2,
						isMaster: true,
						states: ["disposalLoads"],
						getFeatureAccess: function () {
							return getStandardMasterMenuAccess();
						}
					},
					{
						text: function () {
							return labels.SUPPLIER_INDICATIONS;
						},
						level: 2,
						isMaster: true,
						children: [
							{
								text: function () {
									return labels.MARKET_RESIDUE_INFORMATION_GENERATION;
								},
								level: 3,
								isMaster: true,
								states: ["residueMarketBackOfficeSupplierListGeneration"],
								getFeatureAccess: function () {
									return hasMarketBackOfficePermission;
								}
							},
							{
								text: function () {
									return labels.MARKET_RESIDUE_SUPPLIER_BY_REGION;
								},
								level: 3,
								isMaster: true,
								states: ["residueMarketBackOfficeListSupplierByRegion"],
								getFeatureAccess: function () {
									return hasMarketBackOfficePermission;
								}
							}
						]
					},
					{
						text: function () {
							return labels.CHANGE_LOG;
						},
						level: 2,
						isMaster: true,
						states: ["auditTrailList"],
						getFeatureAccess: function () {
							return masterExecuteAdminActionsPermission
								? Vgr.enumerations.userAccess.Enabled
								: Vgr.enumerations.userAccess.Hidden;
						}
					}
				]
			};
		}

		function getStandardMasterMenuAccess() {
			return masterViewClientDataPermission || masterEditClientDataPermission
				? Vgr.enumerations.userAccess.Enabled
				: Vgr.enumerations.userAccess.Hidden;
		}

		$scope.onClickMenuItem = function (menuItem, $event) {
			if ($event) {
				if (menuItem.clickMeasureKey) {
					engagementScoreService.track(menuItem.clickMeasureKey);
				}
				$event.stopPropagation();
				if (menuItem.states) {
					$rootScope.$broadcast(Vgr.constants.evtMenuLinkClick);
					$state.go(menuItem.states[0], menuItem.stateParams);
				}
			} else {
				$scope.toggleAllRelatedToggledItems($scope.userMenu, menuItem);
			}

			$scope.untoggleAllUnrelatedToggledItems($scope.userMenu, menuItem);
			$scope.unsetAllItemsActive($scope.userMenu, menuItem);
			menuItem.toggled = !menuItem.toggled;
			if (menuItem.children) {
				menuItem.active = !menuItem.active;
			} else {
				menuItem.active = true;
			}
		};

		$scope.radioOptions = [
			{
				label: $rootScope.labels.CHANGE_USER_ALL,
				value: "allUsers"
			},
			{
				label: $rootScope.labels.CHANGE_USER_ACTIVE,
				value: "activeUsers"
			},
			{
				label: $rootScope.labels.CHANGE_USER_INACTIVE,
				value: "inactiveUsers"
			}
		];

		$scope.onClickLogout = function () {
			accountService.logoutConditional().then(function (response) {
				if (response) {
					accountService.goToLogin();
				} else {
					accountService.goHome(true);
				}
			});
		};

		$scope.unitList = [];
		$scope.filterUnitModel = {
			query: "",
			onlyPayers: true,
			onlyActives: true
		};
		var loadedAllUnits = false;
		var skip = 0;
		const unitsPerPage = 100;
		var loadingClients = false;

		function resetOrganizationUnitListInSelectUnitComponent() {
			$scope.unitList = [];
			loadedAllUnits = false;
			skip = 0;
		}

		function resetSelectUnitComponentFilters() {
			$scope.filterUnitModel.query = "";
		}

		$scope.firstClientLoad = function () {
			if (loadingClients) {
				return;
			}

			listClients();
		};

		$scope.onChangeSelectUnitFilter = function () {
			resetOrganizationUnitListInSelectUnitComponent();

			listClients();
		};

		$scope.onClientsScrollEnds = function () {
			if (loadingClients) {
				return;
			}

			listClients();
		};

		function listClients() {
			if (loadedAllUnits) {
				return;
			}

			loadingClients = true;

			var dto = {
				query: $scope.filterUnitModel.query,
				skip: skip,
				take: unitsPerPage
			};

			if ($scope.isMaster) {
				dto.active = $scope.filterUnitModel.onlyActives;
				dto.featureIds = $scope.filterUnitModel.onlyPayers ? [Vgr.enumerations.systemFeatures.residuesManagement] : [];
			}

			httpService.getListFromServiceCore(clientService.listOrganizationUnitsToLogin, dto).then(
				function (response) {
					var list = response.list;

					for (var index = 0; index < list.length; index++) {
						list[index].nameToList = buildClientNameForSelectUnitComponent(list[index]);
					}

					$scope.unitList = $scope.unitList.concat(list);
					skip++;
					loadingClients = false;

					if (list.length < unitsPerPage) {
						loadedAllUnits = true;
					}
				},
				function () {
					loadingClients = false;
				}
			);
		}

		function buildClientNameForSelectUnitComponent(client) {
			var description = "";

			if ($scope.isMaster) {
				description += client.organization.id + " - " + client.organization.name + " // ";

				if (client.id == client.code) {
					description += client.id + " - " + client.name;
				} else {
					description += client.id + " - " + client.code + " - " + client.name;
				}

				if (client.city) {
					description += " // " + Vgr.util.capitalizeText(client.city.name) + " - " + client.city.state.abbreviation;
				}
			} else {
				description += client.code + " - " + client.name;

				if (client.city) {
					description += " // " + Vgr.util.capitalizeText(client.city.name) + " - " + client.city.state.abbreviation;
				}
			}

			return description;
		}

		$scope.changeLanguage = function (newLanguage) {
			if (newLanguage != translationService.getLanguage()) {
				var languageSet = translationService.setLanguage(newLanguage);
				if (languageSet) {
					accountService.setUserLanguage(newLanguage).then(function () {
						accountService.removeEntitiesCache();
						window.location.reload();
					});
				}
			}
		};

		$scope.getSelectedLanguageClass = function (language) {
			if ($scope.showLanguages) {
				if (language == translationService.getLanguage()) {
					return "language-option-visible selected";
				}
				return "language-option-visible";
			}
			return "hide";
		};

		$scope.getLanguageSelectorClass = function () {
			if ($scope.showLanguages) {
				return "off-focus";
			}
			return "";
		};

		$scope.openLanguageOptions = function () {
			$scope.showLanguages = !$scope.showLanguages;
		};

		function selectMenuItemFromState(stateName) {
			var currentItem = $scope.findItemByState($scope.userMenu, stateName);
			if (currentItem) {
				$scope.onClickMenuItem(currentItem);
			} else {
				$scope.untoggleAllUnrelatedToggledItems($scope.userMenu, null);
				$scope.unsetAllItemsActive($scope.userMenu, null);
			}
		}

		$scope.$watch("userMenu", function (newVal) {
			if (newVal) {
				selectMenuItemFromState($state.current.name);
			}
		});

		$scope.getParent = function (menuItem, refItem) {
			var parent = null;
			menuItem.hasChildren = $scope.hasChildren;

			if (menuItem.hasChildren()) {
				var child = {};
				for (var i = 0; i < menuItem.children.length; ++i) {
					child = menuItem.children[i];
					child.hasChildren = $scope.hasChildren;

					if ($scope.isEqualToItem(child, refItem)) {
						parent = menuItem;
					} else if (child.hasChildren()) {
						parent = $scope.getParent(child, refItem);
					}

					if (parent) {
						return parent;
					}
				}
			}
			return parent;
		};

		$scope.hasChildren = function hasChildren() {
			if (Array.isArray(this.children)) {
				return this.children.length > 0;
			}
			return false;
		};

		$scope.unsetAllItemsActive = function (menuItem, butItem) {
			if (menuItem.children) {
				for (var i = 0; i < menuItem.children.length; ++i) {
					$scope.unsetAllItemsActive(menuItem.children[i], butItem);
				}
			}
			if (!butItem || butItem.text !== menuItem.text) {
				menuItem.active = false;
			}
		};

		$scope.untoggleAllUnrelatedToggledItems = function (menuItem, refItem) {
			menuItem.hasChildren = $scope.hasChildren;

			if (menuItem.hasChildren()) {
				for (var i = 0; i < menuItem.children.length; ++i) {
					if (menuItem.children[i].children) {
						$scope.untoggleAllUnrelatedToggledItems(menuItem.children[i], refItem);
					}
					if (!$scope.hasChildrenOrEqual(menuItem.children[i], refItem)) {
						menuItem.children[i].toggled = false;
					}
				}
			}
		};

		$scope.toggleAllRelatedToggledItems = function (menuItem, refItem) {
			for (var i = 0; i < menuItem.children.length; ++i) {
				menuItem.children[i].toggled = false;
				if (menuItem.children[i].children) {
					$scope.toggleAllRelatedToggledItems(menuItem.children[i], refItem);
				}
				if ($scope.hasChildrenOrEqual(menuItem.children[i], refItem)) {
					menuItem.children[i].toggled = true;
				}
			}
		};

		$scope.isEqualToItem = function (menuItem, refItem) {
			return refItem && menuItem.text === refItem.text;
		};

		$scope.hasState = function (menuItem, state) {
			if (!menuItem.states) {
				return false;
			}

			for (var i = 0; i < menuItem.states.length; ++i) {
				if (menuItem.states[i] === state) {
					return true;
				}
			}
			return false;
		};

		$scope.findItemByState = function (menuItem, state) {
			var item = null;
			if (!menuItem) {
				return;
			}
			for (var i = 0; i < menuItem.children.length; ++i) {
				if ($scope.hasState(menuItem.children[i], state)) {
					item = menuItem.children[i];
				} else if (menuItem.children[i].children) {
					item = $scope.findItemByState(menuItem.children[i], state);
				}
				if (item) {
					return item;
				}
			}
			return item;
		};

		$scope.hasChildrenOrEqual = function (menuItem, refItem) {
			var hasChildren = false;
			if ($scope.isEqualToItem(menuItem, refItem)) {
				hasChildren = true;
			} else if (menuItem.children) {
				for (var i = 0; i < menuItem.children.length; ++i) {
					if ($scope.isEqualToItem(menuItem.children[i], refItem)) {
						hasChildren = true;
					} else if (menuItem.children[i].children) {
						hasChildren = $scope.hasChildrenOrEqual(menuItem.children[i], refItem);
					}

					if (hasChildren) {
						return true;
					}
				}
			}
			return hasChildren;
		};

		window.addEventListener("click", function (e) {
			var navBar = document.getElementById("navBar");
			var toggleButton = document.getElementById("toggleButton");
			if (navBar && toggleButton) {
				if (
					!document.getElementById("navBar").contains(e.target) &&
					!document.getElementById("toggleButton").contains(e.target)
				) {
					$scope.$apply();
				}
			}
		});

		$scope.onClickOrganizationUnit = function (organizationUnit) {
			$rootScope.$broadcast(Vgr.constants.evtCloseUserNavBar);
			accountService.changeClient(organizationUnit.organization.id, organizationUnit.id).then(function () {
				accountService.goHome(true);
			});
			resetOrganizationUnitListInSelectUnitComponent();
			resetSelectUnitComponentFilters();
		};

		$scope.close = function () {
			$rootScope.$broadcast(Vgr.constants.evtCloseUserNavBar);
		};

		$scope.showAvatar = function () {
			return window.innerHeight >= 420;
		};
	}
]);
